<template>
  <div class="base-popover-with-line" ref="popoverWrap" >
    <transition name="el-fade-in-linear">
      <div v-if="show" class="popover-content" :class="[theme, position]" @click.stop="() => {}">
        <slot name="popover"></slot>
        <div class="popover-line" :style="lineStyle">
          <div class="circle"></div>
          <div class="line"></div>
          <div class="arrow"></div>
        </div>
      </div>
    </transition>
    
    <slot></slot>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    show: Boolean,
    theme: {
      type: String,
      default: 'white',
    },
    position: {
      type: String,
      default: 'bottom',
    },
  },
  data() {
    return {
      contentWidth: 0,
    };
  },
  mounted() {
    this.contentWidth = this.$refs.popoverWrap.offsetWidth;
  },
  computed: {
    lineStyle() {
      if (this.position.indexOf('left') > -1) {
        return {
          left: `${this.contentWidth / 2}px`,
        };
      } else if (this.position.indexOf('right') > -1) {
        return {
          right: `${this.contentWidth / 2}px`,
        };
      }
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.base-popover-with-line{
  position: relative;
  .popover-content{
    cursor: default;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    background: #fff;
    margin-top: 38px;
    border-radius: 4px;
    .popover-line{
      position: absolute;
      bottom: 100%;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 5;
      .circle{
        width: 16px;
        height: 16px;
        background: #CDE2FF;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0;
        border-radius: 50%;
        position: relative;
        z-index: 3;
        &::after{
          content: "";
          width: 8px;
          height: 8px;
          background: #599FFF;
          border-radius: 50%;
        }
      }
      .line{
        position: relative;
        z-index: 2;
        width: 1px;
        height: 20px;
        background: #fff;
        transform: translateX(0.5px);
        box-shadow: 0 0 12px 1px rgba(0,0,0,.3);
      }
      .arrow{
        position: relative;
        z-index: 3;
        border-width: 6px;
        border-style: solid;
        border-color: #fff;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
      }
    }

    &.blue{
      background: #599FFF;
      .popover-line{
        .line{
          background: #599FFF;
        }
        .arrow{
          border-color: #599FFF;
        }
      }
    }
    &[class*="bottom"]{
      top: 100%;
      margin-top: 38px;
      
      .popover-line{
        bottom: 100%;
        .arrow{
          border-top-width: 0;
          margin-top: -1px;          
        }
      }
    }

    &[class*="top"]{
      bottom: 100%;
      margin-bottom: 38px;
      .popover-line{
        top: 100%;
        bottom: auto;
        flex-direction: column-reverse;
        .arrow{
          border-bottom-width: 0;
          margin-bottom: -1px;
        }
      }
    }

    &[class*="left"]{
      left: 0;
      transform: none;
      .popover-line{
        left: 0;
        transform: translateX(-50%);
      }
    }
    &[class*="right"]{
      left: auto;
      right: 0;
      transform: none;
      .popover-line{
        left: auto;
        right: 0;
        transform: translateX(50%);
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/popover/base-popover-with-line.vue